import React from "react";
import "../Logos.css";
import { uploadLogoDetails } from "../../../../../../Redux/actions/projectActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { SHA256 } from 'crypto-js';
import { RxWidth } from "react-icons/rx";


const OVERLAY_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1000,
};

const MODAL_STYLES = {
  position: "fixed",
  top: "35%",
  left: window.innerWidth > 1600 ? "41%" : "35%",
  transform: "translate(-50%, -50%)",
  padding: "50px",
  zIndex: 1000,
  border: "1px solid #fff"
};

const UpdateLogoEdit = ({ setIsUploadingModal, file, setFile, setReLoading, setAlertModal, currentBlockIdx }) => {
  const projectData = useSelector((state) => state.project?.credits);
  const dispatch = useDispatch();

  const handleNo = () => {
    setIsUploadingModal(false);
    setFile({});
  }

  const handleUploadLogo = async(file) => {
    if (
      file?.type !== "image/jpeg" &&
      file?.type !== "image/png" &&
      file?.type !== "image/jpg"
    ) {
      setAlertModal(true)
      return;
    }
    else {
      setIsUploadingModal(false);
      const creditID = projectData ? projectData[currentBlockIdx]?._id : '';
      const fileName = file.name + Date.now();
      const fileType = file.type;
      const fileArrayBuffer = await file.arrayBuffer();
      const fileUint8Array = new Uint8Array(fileArrayBuffer);
      const sha256Hash = SHA256(fileUint8Array).toString();
      if (!fileName || !fileType) {
        toast.error('File Not Selected');
        return;
      } else {
        await setReLoading({ condn: true, label: 'Uploading...' })
        const fileBlob = new Blob([file], { type: fileType });
        const formData = new FormData();
        formData.append('fileName', fileName);
        formData.append('fileType', fileType);
        formData.append('creditID', creditID);
        formData.append('file', file);
        formData.append('shKey', sha256Hash);

        const res = await dispatch(uploadLogoDetails(formData, creditID))
        if (res?.success) {
          // const s3uploadResult = await uploadFileToS3(res?.s3SignedURL, file, fileBlob)
         //  console.log('res ', res)
          await setReLoading({ condn: false, label: '' })
        } else {
          await setReLoading({ condn: false, label: '' })

        }
      }
    }
  }
  return (
    <div>
      <div style={OVERLAY_STYLES} />
      <div
        style={MODAL_STYLES}
        className="containerDeleteLogoEdit bg-gradient-to-r from-[#212226] to-[#3b3d49]  block p-4 text-white absolute"
      >
        <h2 className="Syne700 text-[1.2rem] font-bold mt-2">
          Please Confirm the following
        </h2>
        <p className="w-[25rem] mt-[1rem] text-[0.9rem] text-light text-gray-300">
           By uploading my own custom logo, I acknowledge that I own <b>{file.name}</b> or have the right to use it for my intended purposes.
        </p>
        <div className="flex p-2 gap-4 justify-end mt-4 text-gray-900">
          <button
            onClick={() => handleNo()}
            className="updateLogoEditNoBtn"
          >
            Cancel
          </button>
          <button onClick={() => handleUploadLogo(file)} className="updateLogoEdit">
            Yes, upload away !
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateLogoEdit;
